import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { userSelector } from '../store/reducers/slices/loginSlice';

export const useEmailValidation = () => {
    const user = useSelector(userSelector);

    const correosVendedores = process.env.REACT_APP_CORREOS_VENDEDORES.split(',');

    const [isEmailValid, setIsEmailValid] = useState(false);

    useEffect(() => {
       if(user) setIsEmailValid(correosVendedores.includes(user.email));
    }, [user]);

    return isEmailValid;
};